<template>
    <section id="navigationContainer">
        <TopAppBarDrawerMember v-if="token" @openPattenDialog="openPattenDialog" @closeDrawer="closeDrawer" :noForum="noForum" :noEvent="noEvent" :noticeBoardData="noticeBoardData"></TopAppBarDrawerMember>
        <TopAppBarDrawerGuest v-else  @closeDrawer="closeDrawer"></TopAppBarDrawerGuest>        
    </section>
</template>

<script>
/**
 * 네비게이션 드로워 메인 컴포넌트(navigation drawer main Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCList} from "@material/list";
import {MDCDrawer} from "@material/drawer";
import {MDCDialog} from '@material/dialog';

import TopAppBarDrawerMember from './TopAppBarDrawerMember.vue'
import TopAppBarDrawerGuest from './TopAppBarDrawerGuest.vue'
import loginApi from '@/api/loginApi.js'

export default {
    props: ['isDrawerOpen'],
    components: {
        TopAppBarDrawerMember, TopAppBarDrawerGuest,
    },
    
    data() {
        return {
            token: '',
            routeName: '',
            noForum: false,
            noEvent: false,
            noticeBoardData: false,
        }
    },

    watch:{
        isDrawerOpen: function(value) {
            this.drawer.open = this.isDrawerOpen;
            this.noForum = JSON.parse(localStorage.getItem("noForum"));
            this.noEvent = JSON.parse(localStorage.getItem("noEvent"));
            this.noticeBoardData = JSON.parse(localStorage.getItem("noticeBoardData"));
        },

        $route: function(to, from) {
            this.drawer.open = false
        }
    },

    async mounted() {
        // check login
        await this.checkLogin().then(() => {
            this.token = localStorage.getItem('token');
        });


        this.drawer = MDCDrawer.attachTo(document.querySelector('.mdc-drawer'));
        this.pattenDialog = new MDCDialog(document.querySelector('.mdc-dialog'));
        this.pattenDialog.listen('MDCDialog:opened', () => {});
        
        document.body.addEventListener('MDCDrawer:closed', () => {
            document.body.style.overflow = '';
            this.$emit('closeDrawer');
        });

        document.body.addEventListener('MDCDrawer:opened', () => {
            document.body.style.overflow = 'hidden';
        });  
    },

    destroyed() {
        document.body.style.overflow = ''
    },

    computed: {
        getRouterName() {
            return this.$router.name;
        }
    },

    methods: {
        openPattenDialog() {
            this.drawer.open = false;
            this.pattenDialog.open();
        },

        closeDrawer() {
            this.drawer.open = false;
        },
        
        checkLogin() {
            return new Promise((resolve, reject) => {
                if (localStorage.getItem('token')) {
                    // 로그인 토큰 유효성 체크(check auth token validation)
                    loginApi.validToken().then((response) => {
                        resolve();
                    }).catch((err) => {
                        localStorage.removeItem('token');
                        resolve();
                    })
                }else {
                    resolve();
                }
            })
        }
        
        
    }
}
</script>